module.exports = __webpack_public_path__ + "static/media/hero-background2-414.1883d674.svg";